import { AlertDescriptor } from './alert';

export class DeleteAlert implements AlertDescriptor {
  icon = { name: 'delete_forever', color: '#F27474' };

  constructor(
    public titleText: string,
    public subtitleText: string,
    public confirmButtonText: string,
    public cancelButtonText: string,
    public actionTitleText?: string,
  ) {}
}

export class SuccessAlert implements AlertDescriptor {
  icon = { name: 'check_circle', color: '#3FB23F' };

  constructor(public titleText: string, public subtitleText: string, public confirmButtonText: string) {}
}

export class ConfirmAlert implements AlertDescriptor {
  constructor(
    public titleText: string,
    public subtitleText: string,
    public confirmButtonText: string,
    public cancelButtonText: string,
  ) {}
}
